// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionPlansLayout_root__W3SJ-","subscriptionPlansLayout":"SubscriptionPlansLayout_subscriptionPlansLayout__9nAVP","footer":"SubscriptionPlansLayout_footer__lIufs"};